<template>
  <div class="org-call-log-notify org-business-query-notify">
    <div class="org-business-query-notify__grid">
      <article
        class="org-notify-channel org-notify-channel--email org-notify-channel--compact"
        :class="{ 'org-notify-channel--active': sendBusinessQueriesByEmail }"
      >
        <button
          type="button"
          class="org-notify-channel__head"
          :disabled="disabled"
          @click="onSendEmailChange(!sendBusinessQueriesByEmail)"
        >
          <span class="org-notify-channel__icon org-notify-channel__icon--email" aria-hidden="true">
            <v-icon size="18">mdi-email-outline</v-icon>
          </span>
          <div class="org-notify-channel__intro">
            <h3 class="org-notify-channel__title">Email alerts</h3>
            <p class="org-notify-channel__desc">
              Notify these addresses when a visitor submits a query
            </p>
          </div>
          <span
            class="org-notify-status-pill"
            :class="sendBusinessQueriesByEmail ? 'org-notify-status-pill--on' : 'org-notify-status-pill--off'"
          >
            <v-icon size="13">{{ sendBusinessQueriesByEmail ? 'mdi-check-circle' : 'mdi-close-circle-outline' }}</v-icon>
            {{ sendBusinessQueriesByEmail ? 'On' : 'Off' }}
          </span>
        </button>

        <div v-if="sendBusinessQueriesByEmail" class="org-notify-channel__body">
          <div class="org-notify-recipients org-notify-recipients--compact">
            <AgentItemsTable
              :model-value="businessQueryEmailRows"
              title="Notification emails"
              add-label="Add email"
              empty-text="No emails yet. Add addresses to receive lead alerts."
              value-column-label="Email"
              value-placeholder="name@company.com"
              value-input-type="email"
              prepend-value-icon="mdi-email-outline"
              :value-rules="emailFieldRules"
              :outlined-values="true"
              :show-parameter-name="false"
              :show-required="false"
              :min-rows="0"
              :disabled="disabled"
              @update:model-value="$emit('update:businessQueryEmailRows', $event)"
            />
          </div>
        </div>
      </article>

      <article
        class="org-notify-channel org-notify-channel--whatsapp org-notify-channel--compact"
        :class="{ 'org-notify-channel--active': sendBusinessQueriesByWhatsapp }"
      >
        <button
          type="button"
          class="org-notify-channel__head"
          :disabled="disabled"
          @click="onSendWhatsappChange(!sendBusinessQueriesByWhatsapp)"
        >
          <span class="org-notify-channel__icon org-notify-channel__icon--whatsapp" aria-hidden="true">
            <v-icon size="18">mdi-whatsapp</v-icon>
          </span>
          <div class="org-notify-channel__intro">
            <h3 class="org-notify-channel__title">WhatsApp alerts</h3>
            <p class="org-notify-channel__desc">
              Lead alerts on WhatsApp · 1 credit / message
            </p>
          </div>
          <span
            class="org-notify-status-pill"
            :class="sendBusinessQueriesByWhatsapp ? 'org-notify-status-pill--on' : 'org-notify-status-pill--off'"
          >
            <v-icon size="13">{{ sendBusinessQueriesByWhatsapp ? 'mdi-check-circle' : 'mdi-close-circle-outline' }}</v-icon>
            {{ sendBusinessQueriesByWhatsapp ? 'On' : 'Off' }}
          </span>
        </button>

        <div v-if="sendBusinessQueriesByWhatsapp" class="org-notify-channel__body">
          <div class="org-notify-recipients org-notify-recipients--compact">
            <AgentItemsTable
              :model-value="businessQueryWhatsappRows"
              title="Notification numbers"
              add-label="Add number"
              empty-text="No numbers yet. Add mobiles to receive WhatsApp alerts."
              value-column-label="Mobile"
              value-placeholder="10-digit number"
              value-input-type="text"
              prepend-value-icon="mdi-phone-outline"
              :value-rules="mobileFieldRules"
              :outlined-values="true"
              :show-parameter-name="false"
              :show-required="false"
              :min-rows="0"
              :disabled="disabled"
              @update:model-value="$emit('update:businessQueryWhatsappRows', $event)"
            />
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import AgentItemsTable from '@/components/Organizations/Tabs/AgentItemsTable.vue'
import { isValidEmail, isValidMobile10 } from '@/utils/agentConfiguration'

export default {
  name: 'OrganizationBusinessQueryNotificationFields',
  components: { AgentItemsTable },
  props: {
    sendBusinessQueriesByEmail: { type: Boolean, default: false },
    businessQueryEmailRows: { type: Array, default: () => [] },
    sendBusinessQueriesByWhatsapp: { type: Boolean, default: false },
    businessQueryWhatsappRows: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  emits: [
    'update:sendBusinessQueriesByEmail',
    'update:businessQueryEmailRows',
    'update:sendBusinessQueriesByWhatsapp',
    'update:businessQueryWhatsappRows',
  ],
  computed: {
    emailFieldRules() {
      return [
        (v) => !String(v ?? '').trim() || isValidEmail(v) || 'Enter a valid email',
      ]
    },
    mobileFieldRules() {
      return [
        (v) => !String(v ?? '').trim() || isValidMobile10(v) || 'Enter a valid 10-digit number',
      ]
    },
  },
  methods: {
    onSendEmailChange(value) {
      this.$emit('update:sendBusinessQueriesByEmail', value)
      if (!value) {
        this.$emit('update:businessQueryEmailRows', [])
      }
    },
    onSendWhatsappChange(value) {
      this.$emit('update:sendBusinessQueriesByWhatsapp', value)
      if (!value) {
        this.$emit('update:businessQueryWhatsappRows', [])
      }
    },
  },
}
</script>
